export default "__VITE_ASSET__g0DffN2L__"